import { render, staticRenderFns } from "./wonderful-topic.vue?vue&type=template&id=78d492e0&scoped=true&"
import script from "./wonderful-topic.vue?vue&type=script&lang=js&"
export * from "./wonderful-topic.vue?vue&type=script&lang=js&"
import style0 from "./wonderful-topic.vue?vue&type=style&index=0&id=78d492e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d492e0",
  null
  
)

export default component.exports